module.exports = __webpack_public_path__ + "img/MiddleSchoolAvatar01.7dab77c5.svg";